import { useQuery } from "@tanstack/react-query";
import getRegions from "./regions/get";

export const useRegions = () => {
    return useQuery({
        queryKey: ["regions"],
        queryFn: getRegions,
        initialData: [],
    });
};

